import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import TempPagination from '@material-ui/lab/Pagination';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Link from '@material-ui/core/Link';

const StyledTableCell = withStyles((theme) => ({
	head: {
	  backgroundColor: "#dcdcdc",
	  color: "#999",
	  marginTop: 10,
	  padding: 4,
	  wordBreak: "keep-all",
	},
	body: {
	  fontSize: 14,
	  padding: 4
	},
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
	root: {
	  '&:nth-of-type(even)': {
		backgroundColor: "#f6f6f6",
	  },
	  '&:nth-of-type(odd)': {
		backgroundColor: "#ffffff",
	  },
	},
  }))(TableRow);

  const Pagination = withStyles({
    root: {
      display: 'inline-block',  //右寄せのためインラインブロックに変更
    },
  })(TempPagination);

const styles = theme => ({
    button: {
        display: 'inline-block',
        verticalAlign: 'bottom',
        textAlign: 'center',
        fontSize: '14px',
        lineHeight: '1px',
        height: '32px',
        width: '60px',
        border: '1px solid',
        borderRadius: '3px',
        outline: 0,
        marginLeft: '8px',
        borderColor: '#666',
        color: '#666',
        cursor: 'pointer',
        overflow: 'hidden',
        position: 'relative',
        '&:hover': {
            backgroundColor: '#ccc'
        },
        '&:+.button': {
            marginLeft: 0
        }
    },
    buttonSecondary: {
        backgroundColor: '#666',
        borderColor: '#666',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#444',
            borderColor: '#444'
        }
    },
    buttonPrimary: {
        backgroundColor: '#4ac789',
        borderColor: '#4ac789',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#3ba770',
            borderColor: '#3ba770'
        }
	},
	table: {
		minWidth: 100,
	},
	formControl: {
		minWidth: 159,
	},
});


class StepSettingSiteSearch extends React.Component {

	//親コンポーネントを呼び出す
	//検索入力欄の内容変更
	changeKeyWord(e) {
		this.props.updateKeyWord(e.target.value);
	}

	//親コンポーネントを呼び出す
	//検索
	search(pageid) {
		console.log(pageid)
		this.props.search(this.props.keyword,pageid);
	}

	//親コンポーネントを呼び出す
	//表示形式変更
	changeDispType(e,props) {
		props.updateDispType(e.target.value);
	}

	//親コンポーネントを呼び出す
	//セレクトボックスの内容変更
	changeSelectBox(e) {
		console.log(e)
		this.props.updateSelectBox(e.target.name, e.target.value);
	}

	//親コンポーネントを呼び出す
	//ページネーション
	changePage(e){

		//セレクトボックスボックス変更後に「保存」ボタンを押下する前に
		//ページネーションを行った場合
		if(this.props.isSelectBoxChange){
			let errorMessage = 'ページを変更する前に保存ボタンを押下してセレクトボックスの変更内容を反映してください。'
			this.props.updateIsDispModal(errorMessage)
		}else{

			//最初のページ(1ページ目)
			const FIRST_PAGE_NUM = 1
			//最後のページ
			const LAST_PAGE_NUM = this.props.pagenum 		

			const FIRST_PAGE = "Go to first page"
			const PREV_PAGE = "Go to previous page"
			const NEXT_PAGE = "Go to next page"
			const LAST_PAGE = "Go to last page"

			//最初のページを選択した場合
			if(e.currentTarget.ariaLabel == FIRST_PAGE){
				this.props.search(this.props.keyword,FIRST_PAGE_NUM);
			//前のページを選択した場合
			}else if(e.currentTarget.ariaLabel == PREV_PAGE){
				this.props.search(this.props.keyword,this.props.currentPage - 1);
			//次のページを選択した場合
			}else if(e.currentTarget.ariaLabel == NEXT_PAGE){
				this.props.search(this.props.keyword,this.props.currentPage + 1);
			//最後のページを選択した場合
			}else if(e.currentTarget.ariaLabel == LAST_PAGE){
				this.props.search(this.props.keyword,LAST_PAGE_NUM);
			//特定のページを選択した場合
			}else{
				this.props.search(this.props.keyword,Number(e.currentTarget.innerText));
			}
		}
	}

	//親コンポーネントを呼び出す
	handleCloseModal() {
		this.props.closeModal();
	}
	
	render() {

		console.log(this.props)

		const { classes } = this.props;

		const page_first = 1;
		const PAGE_URL_INDEX = 0
		const WORD_RANK_INDEX = 1

		//stepの初期化
		let modal = [];
		let searchList = [];		

		//URL表示
		const URL_DISP = 0

		console.log(this.props.isDispModal)
		console.log(this.props.isDispSearchList)

		//モーダル表示フラグ
		if(this.props.isDispModal){
			modal.push(
				<div className="modal" style={{display: "block"}}>
					<div className="over-lay modal-close" onClick={() => { this.handleCloseModal(); }}></div>
					<div className="modal-inner" style={{width: "300px", animation: "0.3s ease 0s 1 normal forwards running modal"}} >
						<div className="modal-header">
							<span className="modal-title">エラー</span>
							<CloseIcon className="icon-close modal-close" style={{ fontSize: 19}} onClick={() => { this.handleCloseModal(); }}/>
						</div>
						<div className="modal-contents">{this.props.modalErrorMessage}</div>
						<button id="button-close" className="button modal-close" onClick={() => { this.handleCloseModal(); }}>OK</button>
					</div>
				</div>
			)
		}

		//検索結果の表示形式
		let dispTypeList = []
		dispTypeList.push(
			<FormControl variant="outlined" size="small"className={classes.formControl}>
				<Select 
					defaultValue={0} 
					style={{ backgroundColor: "#ffffff", textAlign: "left"}} 
					onChange={(e) => { this.changeDispType(e,this.props)}} 
					value={this.props.isURLDisp}
				>
					<MenuItem value={0}>URL</MenuItem>
					<MenuItem value={1}>ページタイトル</MenuItem>
				</Select>
			</FormControl>
		)

		//ページネーション
		let pageNationArea = []
		pageNationArea.push(
			<Pagination 
				count={this.props.pagenum} 
				variant="outlined" 
				shape="rounded" 
				size="small" 
				page={this.props.currentPage}
				onChange={(e) => { this.changePage(e)}}
				showFirstButton 
				showLastButton  />
		)

		//検索結果表示フラグ
		if(this.props.isDispSearchList){
			//URL表示の場合
			if(this.props.isURLDisp == URL_DISP){
				searchList.push(
					<div  style={{ marginTop: "20px", textAlign: "right"}}>
						<div style={{ float: "left" , marginTop : "-10px", marginBottom : "10px"}}>
							{dispTypeList}
						</div>
						<div className="description">
							検索結果{this.props.totalnum}件
						</div>
					</div>,
					<TableContainer style={{ marginTop: "10px"}}>
						<Table>
							<TableHead>
								<TableRow>
								<StyledTableCell>検索順</StyledTableCell>
								<StyledTableCell>URL</StyledTableCell>
								<StyledTableCell align="center">検索順の指定</StyledTableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{(this.props.searchResultList).map((row,index) => (
								<StyledTableRow key={index+1}>
									<StyledTableCell>{index+1}</StyledTableCell>
									<StyledTableCell>
										<Link href={row.page_url} style={{ color: "#7ec296", wordBreak: "break-word"}} target="_blank" rel="noopener noreferrer">
											{row.page_url}<OpenInNewIcon  fontSize="small" style={{ marginLeft: 4, verticalAlign: 'middle' }}/>
										</Link>
									</StyledTableCell>
									<StyledTableCell align="right">
										<FormControl variant="outlined" size="small"className={classes.formControl}>
											<Select 
												defaultValue={99}
												value={this.props.searchResulSelectBox[index][WORD_RANK_INDEX]}
												name={String(index)}
												onChange={(e) => { this.changeSelectBox(e)}} 
												style={{ backgroundColor: "#ffffff", textAlign : "left"}} 
											>
												<MenuItem value={99}>指定しない</MenuItem>
												<MenuItem value={1}>1番目</MenuItem>
												<MenuItem value={2}>2番目</MenuItem>
												<MenuItem value={3}>3番目</MenuItem>
												<MenuItem value={4}>4番目</MenuItem>
												<MenuItem value={5}>5番目</MenuItem>
											</Select>
										</FormControl>
									</StyledTableCell>
								</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>,
					<div  style={{ marginTop: "10px", textAlign: "right"}}>
						{pageNationArea}
					</div>
				)
			
			//タイトル表示の場合
			}else{
				searchList.push(
					<div  style={{ marginTop: "20px", textAlign: "right"}}>
						<div style={{ float: "left" , marginTop : "-10px", marginBottom : "10px"}}>
							{dispTypeList}
						</div>
						<div className="description">
							検索結果{this.props.totalnum}件
						</div>
					</div>,
					<TableContainer style={{ marginTop: "10px"}}>
						<Table>
							<TableHead>
								<TableRow>
								<StyledTableCell>検索順</StyledTableCell>
								<StyledTableCell >ページタイトル</StyledTableCell>
								<StyledTableCell align="center">検索順の指定</StyledTableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{(this.props.searchResultList).map((row,index) => (
								<StyledTableRow key={index+1}>
									<StyledTableCell>{index+1}</StyledTableCell>
									<StyledTableCell>
										<Link href={row.page_url} style={{ color: "#7ec296", wordBreak: "break-word"}} target="_blank" rel="noopener noreferrer">
											{row.title}<OpenInNewIcon  fontSize="small" style={{ marginLeft: 4, verticalAlign: 'middle' }}/>
										</Link>
									</StyledTableCell>
									<StyledTableCell align="right">
										<FormControl variant="outlined" size="small"className={classes.formControl}>
											<Select 
												defaultValue={99}
												value={this.props.searchResulSelectBox[index][WORD_RANK_INDEX]}
												name={String(index)}
												onChange={(e) => { this.changeSelectBox(e)}} 
												style={{ backgroundColor: "#ffffff", textAlign : "left"}} 
											>
												<MenuItem value={99}>指定しない</MenuItem>
												<MenuItem value={1}>1番目</MenuItem>
												<MenuItem value={2}>2番目</MenuItem>
												<MenuItem value={3}>3番目</MenuItem>
												<MenuItem value={4}>4番目</MenuItem>
												<MenuItem value={5}>5番目</MenuItem>
											</Select>
										</FormControl>
									</StyledTableCell>
								</StyledTableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>,
					<div  style={{ marginTop: "10px", textAlign: "right"}}>
						{pageNationArea}
					</div>
				)
			}
		}

		return (
			<div id="contents_body">
				<p className="">
					特定のキーワードに対しての検索順位を、上位5位まで設定することができます。
				</p>
				<p className="description">
					対象ドメイン：https://{ this.props.searchdomain }
				</p>
				<div className="searcharea">
					<input type="text" name="domeign" id="domeign" className="search-input" maxLength="100" placeholder="キーワードを入力" 
						value={this.props.keyword} onChange={(e) => { this.changeKeyWord(e); }}
					/>
					<Button id="btn-next" className={`${classes.button} ${classes.buttonPrimary}`} onClick={() => { this.search(page_first); }}>検索</Button>
				</div>
				{searchList}
				{modal}
			</div>
		);
  	}
}

export default withStyles(styles)(StepSettingSiteSearch)